import React from 'react';

export default function FlightInformationCard({
  activeBooking,
  routeFrom,
  routeTo,
  notes,
}) {
  const briefing =
    activeBooking?.briefing_data || {};

  const flightType = String(
    briefing.flightType ||
      briefing.flight_type ||
      ''
  )
    .trim()
    .toLowerCase();

  const returningFrom =
    briefing.departureAirfield ||
    briefing.departure_airfield ||
    routeFrom ||
    'Not set';

  const destination =
    briefing.destinationAirfield ||
    briefing.destination_airfield ||
    routeTo ||
    'Not set';

  const purpose = String(
    briefing.flightPurpose ||
      briefing.purpose ||
      ''
  ).toLowerCase();

  const isCircuits =
    flightType === 'circuits' ||
    purpose.includes('circuit') ||
    purpose.includes('touch');

  const isLocal =
    flightType === 'local' ||
    (!flightType &&
      returningFrom === destination);

  let routeDisplay;

  if (isCircuits) {
    routeDisplay = (
      <>
        <div style={styles.cardValue}>
          Circuit training
        </div>

        <div style={styles.routeSubText}>
          {destination}
        </div>
      </>
    );
  } else if (isLocal) {
    routeDisplay = (
      <>
        <div style={styles.cardValue}>
          Local flight
        </div>

        <div style={styles.routeSubText}>
          {destination}
        </div>
      </>
    );
  } else {
    routeDisplay = (
      <div style={styles.routeLegs}>
        <div style={styles.routeLeg}>
          <div style={styles.routeLegLabel}>
            Outbound
          </div>

          <div style={styles.cardValue}>
            To {destination}
          </div>
        </div>

        <div style={styles.routeDivider} />

        <div style={styles.routeLeg}>
          <div style={styles.routeLegLabel}>
            Return
          </div>

          <div style={styles.cardValue}>
            From {returningFrom}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.sectionGrid}>
      <InfoCard
        label="Pilot"
        value={
          activeBooking.pilotName ||
          'Not provided'
        }
      />

      <InfoCard
        label="Route"
        value={routeDisplay}
      />

      {notes && (
        <InfoCard
          label="Flight Notes"
          value={notes}
        />
      )}
    </div>
  );
}

function InfoCard({
  label,
  value,
}) {
  return (
    <div style={styles.infoCard}>
      <div style={styles.cardLabel}>
        {label}
      </div>

      {typeof value === 'string' ? (
        <div style={styles.cardValue}>
          {value}
        </div>
      ) : (
        value
      )}
    </div>
  );
}

const styles = {
  sectionGrid: {
    display: 'grid',
    gap: '0.65rem',
    marginTop: '1.1rem',
  },

  infoCard: {
    padding: '0.75rem 0.85rem',
    borderRadius: 14,
    background:
      'rgba(255,255,255,0.045)',
    border:
      '1px solid rgba(255,255,255,0.08)',
  },

  cardLabel: {
    color: '#8db7e6',
    fontSize: '0.68rem',
    fontWeight: 950,
    letterSpacing: '0.11em',
    textTransform: 'uppercase',
    marginBottom: '0.25rem',
  },

  cardValue: {
    color: '#ffffff',
    fontSize: '0.95rem',
    fontWeight: 750,
    lineHeight: 1.45,
  },

  routeSubText: {
    color: '#8db7e6',
    fontSize: '0.82rem',
    marginTop: 2,
    fontWeight: 700,
  },

  routeLegs: {
    display: 'grid',
    gridTemplateColumns:
      'minmax(0, 1fr) 1px minmax(0, 1fr)',
    gap: '0.85rem',
    alignItems: 'stretch',
  },

  routeLeg: {
    minWidth: 0,
  },

  routeLegLabel: {
    color: '#55c7ff',
    fontSize: '0.67rem',
    fontWeight: 900,
    letterSpacing: '0.09em',
    textTransform: 'uppercase',
    marginBottom: '0.2rem',
  },

  routeDivider: {
    width: 1,
    background:
      'rgba(255,255,255,0.10)',
  },
};